import PaginationData from "@/models/general/PaginationData";
import Payment from "@/models/reservations/payments/Payment";
import PaymentsFilter from "@/models/reservations/payments/PaymentsFilter";

export default class Payments {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.paymentsData = [];
    this.payment = new Payment();
    this.filterData = new PaymentsFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.pagination);
    this.paymentsData = data.reservationsSchedulesPaymentsDatas;
  }
}
